import actionTypes from './actionTypes';

export const requestWorkTemplates = data => ({
  type: actionTypes.REQUEST_WORK_TEMPLATES,
  data,
});

export const getWorkTemplatesSuccess = data => ({
  type: actionTypes.GET_WORK_TEMPLATES_SUCCESS,
  data,
});

export const getWorkTemplatesFailure = () => ({
  type: actionTypes.GET_WORK_TEMPLATES_FAILURE,
});

export const getWorkTemplatesTotalSuccess = data => ({
  type: actionTypes.GET_WORK_TEMPLATES_TOTAL_SUCCESS,
  data,
});
